import { forwardRef } from 'react';

import { WithStyles, createStyles, withStyles } from '@material-ui/core';

import classNames from 'classnames';

import { Flex, FlexProps } from '@backstage/ui';

const styles = createStyles({
  root: {
    backgroundColor: 'var(--bui-bg-surface-1)',
    padding: 'var(--bui-space-1) var(--bui-space-2)',
    borderRadius: 'var(--bui-radius-2)',
    flexWrap: 'wrap',
  },
  noWrap: {
    flexWrap: 'nowrap',
  },
});

export interface ExpressionGroupProps
  extends FlexProps,
    WithStyles<typeof styles> {
  disableWrap?: boolean;
}

const ExpressionGroup = forwardRef<HTMLDivElement, ExpressionGroupProps>(
  (props, ref) => {
    const { classes, className, disableWrap, ...rest } = props;
    return (
      <Flex
        ref={ref}
        direction="row"
        align="center"
        className={classNames(
          className,
          classes.root,
          disableWrap && classes.noWrap,
        )}
        gap="1"
        {...rest}
      />
    );
  },
);

ExpressionGroup.displayName = 'Expression.Group';

export default withStyles(styles)(ExpressionGroup);
